const IP_ADDRESS_EXTERNAL_URL = 'https://api.ipify.org/?format=json';
export const getClientIpAddress = async (): Promise<string> => {
  const ipAddressKey = "clientIpAddress";

  const storedIpAddress = localStorage.getItem(ipAddressKey);
  if (storedIpAddress) {
    return Promise.resolve(storedIpAddress);
  }

  try {
    const response = await fetch(`${IP_ADDRESS_EXTERNAL_URL}`);
    const data = await response.json();
    const ipAddress = data.ip;
    localStorage.setItem(ipAddressKey, ipAddress);
    return ipAddress;
  } catch (error) {
    console.error("Error getting IP address:", error);
    return "unknown";
  }
};

export const clearClientIpAddress = (): void => {
  localStorage.removeItem("clientIpAddress");
};
